import {
	type Action,
	CHECKBOX_SELECTION_MODE,
} from '../../../../actions/cards/checkbox-selection-mode';
import type { CheckboxSelectionMode } from './types';

const initialState: CheckboxSelectionMode = false;

export type { Action };

export const checkboxSelectionModeReducer = (
	state: CheckboxSelectionMode = initialState,
	action: Action,
): CheckboxSelectionMode => {
	if (action.type === CHECKBOX_SELECTION_MODE) {
		return action.payload.isCheckboxSelectionMode;
	}

	return state;
};
